import request, { saveToken } from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'auth';

const authService = {
  login: async (data) => {
    const resp = await request({
      method: Methods.POST,
      resource: `${baseURL}/login`,
      data,
    });
    if (resp.token) {
      saveToken(resp.token);
      delete resp.token;
    }
    return resp;
  },
};

export default authService;
